module.exports = __webpack_public_path__ + "img/bag3.82385d27.jpg";